var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33317 12.5352C2.32818 11.8625 1.6665 10.7168 1.6665 9.41667C1.6665 7.46369 3.15943 5.85941 5.06629 5.68281C5.45635 3.31011 7.51671 1.5 9.99984 1.5C12.483 1.5 14.5433 3.31011 14.9334 5.68281C16.8402 5.85941 18.3332 7.46369 18.3332 9.41667C18.3332 10.7168 17.6715 11.8625 16.6665 12.5352M6.6665 13.1667L9.99984 16.5M9.99984 16.5L13.3332 13.1667M9.99984 16.5V9",
    stroke: "#2A364A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.8a7c6d77cff22d9249189a83bda2dafd.svg";
export { ForwardRef as ReactComponent };